import React from 'react'
import moment from 'moment'

const CalendarWeekDays = ({ currentDate }) => {
  const weekDays = []
  let startDate = moment(currentDate).startOf('week')

  let headingDateFormat = 'dd'

  if (process.env.REACT_APP_FORMAT_CALENDER_CELL_HEADINGS_DATE) {
    headingDateFormat = process.env.REACT_APP_FORMAT_CALENDER_CELL_HEADINGS_DATE
  }

  for (let i = 0; i < 7; i++) {
    weekDays.push(
      <div className="u-calendar__day" key={i}>
        <span className="u-desktop-only">
          {moment(startDate).add(i, 'days').format(headingDateFormat)}
        </span>
        <span className="u-mobile-only">
          {moment(startDate).add(i, 'days').format('dd')}
        </span>
      </div>
    )
  }
  return <div className="u-calendar__days">{weekDays}</div>
}

export default CalendarWeekDays
